import React from 'react';

import { MjmlSection, MjmlColumn, MjmlSpacer } from '../MjmlComponentsV2';

/**
 * @deprecated This component has been moved to @emails library (libs/emails/src/lib/components/EmailSpacer.tsx).
 * Please import from 'emails' package instead.
 */
export function EmailSpacer() {
  return (
    <MjmlSection>
      <MjmlColumn>
        <MjmlSpacer padding="0" height="0" />
      </MjmlColumn>
    </MjmlSection>
  );
}
